import React, {useState} from 'react';

import {ClientData, QuestionnaireRequestParams, SignupRequestParams} from '../../../../types/src';
import {RegisterStep1} from './RegisterStep1';
import {RegisterStep2} from './RegisterStep2';

interface RegisterFormProps {
  client: ClientData;
  signup: (params: SignupRequestParams) => Promise<boolean>;
  onboardQuestionnaire: (params: QuestionnaireRequestParams) => Promise<void>;
  onboardQuestionnaireSkip: () => Promise<void>;
  analyticsService: any;
}

export const RegisterForm = ({
  client,
  signup,
  onboardQuestionnaire,
  onboardQuestionnaireSkip,
  analyticsService,
}: RegisterFormProps) => {
  const [step, setStep] = useState<1 | 2>(1);

  const goToStep2 = () => {
    setStep(2);
  };

  if (step === 1) {
    return <RegisterStep1 client={client} signup={signup} goToStep2={goToStep2} analyticsService={analyticsService} />;
  }
  return (
    <RegisterStep2
      client={client}
      onboardQuestionnaire={onboardQuestionnaire}
      onboardQuestionnaireSkip={onboardQuestionnaireSkip}
    />
  );
};
